/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderCornerIos = createReactComponent("outline", "border-corner-ios", "IconBorderCornerIos", [["path", { "d": "M4 20c0 -6.559 0 -9.838 1.628 -12.162a9 9 0 0 1 2.21 -2.21c2.324 -1.628 5.602 -1.628 12.162 -1.628", "key": "svg-0" }]]);

export { IconBorderCornerIos as default };
//# sourceMappingURL=IconBorderCornerIos.mjs.map
